// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"8fa49c5f","513":"76380356","703":"48598b66"}[chunkId] + ".chunk.js";
};